

























































































































import FormAsignacionVehiculos from './FormAsignacionVehiculos.vue';
import FormEditarAsignacionVehiculos from './FormEditarAsignacionVehiculos.vue';
import FormAsignarEsquema from './FormAsignarEsquema.vue';

import moment from 'moment';
import { ComponenteBase } from '@/views/base/ComponenteBase';
import config from '@/config/index';
import { Component } from 'vue-property-decorator';
import { IFuncionalidad } from '@/interfaces/Funcionalidad';
import { Accion } from '@/config/enums';
import { AxiosVue } from '@/AxiosVue';
import { ServicioProxy } from '@/config/enums';
import { Funcionalidades } from '@/config/funcionalidades';
import { eventBus, actionsEvent } from '@/setup';
import HandleErrors from '../../config/handleErrors';
import store from '@/store';
import { PermisoAccion } from '@/views/base/VariablesPermisos';
import { fetchMID } from './fetchMID';
import Confirmation from '@/components/Confirmation.vue'; //

import {
  GridOptions,
  GridApi,
  ColumnApi,
  ColDef,
  GridReadyEvent,
  RowNode,
} from 'ag-grid-community';
import MantenedorGridSinCodigo from '@/reusable/Grid/MantenedorGridSinCodigo.vue';
import { LoadingService } from '@/services/loadingService';
import loadingEventBus from '@/loadingEventBus';

@Component({
  components: {
    MantenedorGridSinCodigo,
    FormEditarAsignacionVehiculos,
    FormAsignacionVehiculos,
    FormAsignarEsquema,
    'app-confirmacion': Confirmation,
  },
})
export default class AsignacionvehiculosWS extends ComponenteBase {
  [x: string]: any;
  dialogConfirmacionClose: boolean = false;
  filtro: any = '';
  ordesList: any[] = [];
  funcionalidad: Funcionalidades = Funcionalidades.AsignacionvehiculosWS;
  clienteId: number = config.getClienteSesion();
  selectedItem: any;
  endPoints: any = [];
  dataTotal: any = [];
  sinEsquema: any = [];
  asignarEsquema: any = [];
  clientes: any[] = [];
  clientesAll: any = [];
  showTables = false;
  groupBy: any = [{ key: 'flota', order: 'asc' }];
  message: '¡Mensaje al pasar el mouse!';
  timeout: 2000; // Tiempo en milisegundos que se mostrará el mensaje
  loadingService: any = new LoadingService();

  formFields: {
    clientes: any;
  } = {
    clientes: {
      label: 'Clientes',
      value: '',
      items: this.clientesall,
      formatItem: (item: { nombre: any; rut: any }) =>
        `${item.nombre} [${item.rut}]`,
    },
  };

  showMessage(value: boolean) {
    this.showTooltip = true;
  }

  async getEndpoint() {
    let self = this;
    this.loadingService.showLoading();
    return fetchMID(
      { clienteid: this.formFields.clientes.value.toString() },
      'mid_cliente/GetTotalVehiculosIntegrador'
    )
      .then((data: any) => {
        if (data.data.CODIGO_RESPUESTA == '1') {
          return data.data.data;
        } else {
          self.$snotify.error(data.data.MENSAJE_RESPUESTA, { timeout: 3000 });
        }
      })
      .catch((error: any) => {
        console.error('Error:', error);
        self.$snotify.error('Ocurrió un error a', { timeout: 3000 });
      })
      .finally(() => {
        this.loadingService.hideLoading();
        return null;
      });
  }

  showLoading() {
    this.requestsStart += 1;
    if (this.requestsStart == 1) {
      this.loadingService.showLoading();
    }
  }
  hideLoading() {
    this.requestsStart -= 1;
    if (this.requestsStart == 0) {
      this.loadingService.hideLoading();
    }
  }

  /* async getIntegracionesFaltantes() {
    let self = this;
    this.loadingService.showLoading();
    return fetchMID(
      { clienteid: this.formFields.clientes.value.toString() },
      'mid_cliente/GetintegracionesFaltantes '
    )
      .then((data: any) => {
        if (data.data.CODIGO_RESPUESTA == '1') {
          return data.data.data;
        } else {
          self.$snotify.error(data.data.MENSAJE_RESPUESTA, { timeout: 3000 });
        }
      })
      .catch((error: any) => {
        self.$snotify.error('Ocurrió un error b', { timeout: 3000 });
      })
      .finally(() => {
        this.loadingService.hideLoading();
        return null;
      });
  } */
  compras: any;
  delete: any;

  usuarioActivo: any = {};

  async datoEditado(dato: boolean) {
    if (dato) {
      this.ordesList = (await this.getEndpoint()) || [];
      this.gridApi.setRowData(
        this.ordesList
          .map(item => ({
            nombre_ws: item.nombre_ws,
            total_vehiculos: item.total_vehiculos,
            integrador: item.integracion.integrador,
            id: item.integracion.id,
          }))
          .sort((a: any, b: any) => {
            if (a.nombre_ws > b.nombre_ws) {
              return 1;
            } else if (a.nombre_ws < b.nombre_ws) {
              return -1;
            } else {
              return 0;
            }
          })
      );
    }
  }

  async datoNuevo(dato: any) {
    if (dato) {
      this.ordesList = (await this.getEndpoint()) || [];
      this.gridApi.setRowData(
        this.ordesList
          .map(item => ({
            nombre_ws: item.nombre_ws,
            total_vehiculos: item.total_vehiculos,
            integrador: item.integracion.integrador,
            id: item.integracion.id,
          }))
          .sort((a: any, b: any) => {
            if (a.nombre_ws > b.nombre_ws) {
              return 1;
            } else if (a.nombre_ws < b.nombre_ws) {
              return -1;
            } else {
              return 0;
            }
          })
      );
    }
  }
  async showTable() {
    if (
      this.formFields.clientes.value == '' ||
      this.formFields.clientes.value === null ||
      this.formFields.clientes.value === undefined
    ) {
      this.showTables = false;
      this.orderList = [];
      this.endPoints = [];
      this.sinEsquema = [];
      this.asignarEsquema = [];
      this.$snotify.error('Selecione un cliente', { timeout: 3000 });
    } else {
      this.showTables = true;
      sessionStorage.setItem('clienteMid', this.formFields.clientes.value);
      this.ordesList = (await this.getEndpoint()) || [];
      const transformedData = this.ordesList
        .map(item => ({
          nombre_ws: item.nombre_ws,
          total_vehiculos: item.total_vehiculos,
          integrador: item.integracion.integrador,
          id: item.integracion.id,
        }))
        .sort((a: any, b: any) => {
          if (a.nombre_ws > b.nombre_ws) {
            return 1;
          } else if (a.nombre_ws < b.nombre_ws) {
            return -1;
          } else {
            return 0;
          }
        });
      this.endPoints = this.ordesList
        .map(item => ({
          id: item.integracion.id,
          nombre_ws: item.nombre_ws,
        }))
        .sort((a: any, b: any) => {
          if (a.nombre_ws > b.nombre_ws) {
            return 1;
          } else if (a.nombre_ws < b.nombre_ws) {
            return -1;
          } else {
            return 0;
          }
        });
      /* this.sinEsquema = (await this.getIntegracionesFaltantes()) || [];
      this.asignarEsquema = this.sinEsquema
        .filter(
          (item: { nombrewebservice: string }) => item.nombrewebservice !== ''
        )
        .map((item: { nombrewebservice: any; id: any }) => ({
          nombrewebservice: item.nombrewebservice,
          id: item.id,
        }))
        .sort((a: any, b: any) => {
          if (a.nombrewebservice > b.nombrewebservice) {
            return 1;
          } else if (a.nombrewebservice < b.nombrewebservice) {
            return -1;
          } else {
            return 0;
          }
        }); */
      this.clientes = (await this.getAllCliente()) || [];
      const filteredData = this.clientes
        .map(item => ({
          nombre: item.nombre,
          rut: item.rut,
          id: item.id,
        }))
        .sort((a: any, b: any) => {
          if (a.nombre > b.nombre) {
            return 1;
          } else if (a.nombre < b.nombre) {
            return -1;
          } else {
            return 0;
          }
        });
      if (filteredData.length > 0) {
        this.clientesAll = filteredData;
      }
      this.gridApi.setRowData(transformedData);
      this.gridApi.setDomLayout('autoHeight');
    }
  }
  async clearFilters() {
    this.formFields.clientes.value = undefined;
    this.showTables = false;
    this.orderList = [];
    this.endPoints = [];
    this.sinEsquema = [];
    this.asignarEsquema = [];
  }
  async handleGridReady(event: GridReadyEvent) {
    /* this.clientes = (await this.getAllCliente()) || [];
    const filteredData = this.clientes
      .map(item => ({
        nombre: item.nombre,
        rut: item.rut,
        id: item.id,
      }))
      .sort((a: any, b: any) => {
        if (a.nombre > b.nombre) {
          return 1;
        } else if (a.nombre < b.nombre) {
          return -1;
        } else {
          return 0;
        }
      });
  
    if (filteredData.length > 0) {
      this.clientesAll = filteredData;
    } */
    this.gridApi = event.api;
  }

  onModelUpdated() {
    if (!this.gridApi) {
      return;
    }
  }

  onSelectionChanged(params: any) {}

  showModalNew = false;
  pasoActivoIndex = 1;
  pasoActivoEditar = 1;

  //Declarar todas las Acciones Mantenedores
  accionConsultar: PermisoAccion = {
    accionCodigo: 1,
    visible: false,
  };

  accionCrear: PermisoAccion = {
    accionCodigo: 2,
    visible: false,
  };

  accionesTotales: PermisoAccion[] = [this.accionConsultar, this.accionCrear];

  // Globales
  tabModel: string = 'tab-3';
  dialog: Boolean = false;
  search: string = '';

  gridOptions: GridOptions;

  intervalo: any; //Intervalo para el buscador
  chequearPermisosBtnCrear: boolean = true;
  editedIndex: number = -1;

  handleErrors: HandleErrors = new HandleErrors();

  // Controller
  readonly controller: string = 'funcionalidad';
  readonly controllerModuloAccion: string = 'moduloaccion';
  axios: AxiosVue = new AxiosVue(ServicioProxy.GestionUsuario);

  // Grilla
  gridApi: GridApi;
  columnApi: ColumnApi;
  columnDefs: Array<ColDef> = [];
  serverSide: any;

  // Interfaces
  editedItem: IFuncionalidad = {};
  funcionalidades: Array<IFuncionalidad> = [];

  //vuex
  usuarioId: number = store.state.userId;

  // Componentes
  //showModalNew: boolean = false;
  showModalEdit: boolean = false;
  modalEsEdicion: boolean = false;
  showModalAsignar: boolean = false;

  constructor() {
    super();

    this.columnDefs = [
      {
        headerName: 'Endpoints',
        field: 'nombre_ws',
        resizable: true,
        sortable: true,
        hide: false,
        minWidth: 320,
        width: 320,
        lockPinned: true,
        cellStyle: { textAlign: 'left' },
      },
      {
        headerName: 'Total Vehículos Asignados',
        field: 'total_vehiculos',
        resizable: true,
        sortable: true,
        width: 320,
        minWidth: 200,
        lockPinned: true,
      },
      {
        headerName: 'Integrador',
        field: 'integrador',
        resizable: true,
        sortable: true,
        width: 320,
        minWidth: 320,
        lockPinned: true,
      },
      {
        headerName: 'Descargar',
        field: 'descargar',
        cellStyle: { textAlign: 'left' },
        type: 'medalColumn',
        tooltipField: 'country',
        cellRenderer: () => {
          return '<i class="material-icons" id="5545" title="Descargar" style="width: 28px; height: 28px; margin-top: 10%" >download</i>';
        },
        onCellClicked: this.handleClickInfo,
        columnGroupShow: 'closed',
      },
    ];

    this.gridOptions = {
      pagination: true,
      paginationPageSize: 6,
      rowModelType: 'normal',
      columnDefs: this.columnDefs,
      serverSideDatasource: this.serverSide,
      rowSelection: 'single',
      columnTypes: {
        fecha: {
          sortable: true,
          resizable: true,
          filter: false,
        },
      },
      suppressCsvExport: true,
      suppressExcelExport: true,
      onGridReady: this.handleGridReady,
      onModelUpdated: this.onModelUpdated,
      onSelectionChanged: this.onSelectionChanged,

      processCellForClipboard: ({ value }) => {
        return value instanceof moment
          ? this.formatFecha(value as moment.Moment)
          : value;
      },
      onGridSizeChanged: event => {
        //event.api.sizeColumnsToFit();
      },
    };
  }

  mounted() {
    eventBus.changeTitlePage('Módulos');
    loadingEventBus.$emit('loading', true, 'Por favor espere...');
    this.getAllCliente();
    setTimeout(() => {
      loadingEventBus.$emit('loading', false, undefined);
    }, 10000);
  }

  created() {
    this.initialize();
  }

  async handleClickInfo(event: any) {
    var filename =
      'Reporte_MID_' + moment().format('DD_MM_YYYY_HH_mm_ss_SSS') + '.csv';

    var informeData = {
      filename: filename,
      canal: 'gpschile',
      ...event.data,
      cliente: this.formFields.clientes.value,
    };
    console.log('descargar', informeData);
    this.loadingService.showLoading();
    return fetchMID(informeData, 'mid_cliente/download')
      .then((data: any) => {
        // console.log("data",data)
        if (data.data.CODIGO_RESPUESTA == '1') {
          var tk = data.data.token;
          let _url_base = process.env.VUE_APP_SERVICIO_MS;
          window.open(_url_base + 'descarga_reporte?tk=' + tk, '_blank');
          // return data.data.data;
        } else {
          this.$snotify.error('No se pudo descargar el reporte', {
            timeout: 3000,
          });
        }
      })
      .finally(() => {
        this.loadingService.hideLoading();
      });
  }

  onFilterTextBoxChanged() {
    clearInterval(this.intervalo);
    const self = this;
    this.intervalo = setInterval(function() {
      if (self.search.length >= 2) {
        self.gridApi.onFilterChanged();
      } else if (self.search.length === 0) {
        self.gridApi.setServerSideDatasource(self.serverSide);
      }
      clearInterval(self.intervalo);
    }, 500);
  }
  rutSelected: string = '';
  initialize() {
    actionsEvent.$on('actionsEvent', (data: any) => {
      if (this.funcionalidad === Funcionalidades.AsignacionvehiculosWS) {
        if (data.action === Accion.Editar) {
          this.editedItem = null;
          // Editar - Ver Detalle
          this.modalEsEdicion = data.action == Accion.Editar;
          this.editedIndex = data.id;
          let item: any = null;
          this.gridApi.forEachNode((rowNode: RowNode) => {
            if (data.id == rowNode.data.id) {
              item = rowNode.data;
              return true;
            }
          });
          if (item !== null) {
            this.showModalEdit = true;
            this.editedItem = data.cellRendererParams.data.proveedorrut;
          }
        }
      }
    });
  }
  async getAllCliente() {
    let self = this;
    this.loadingService.showLoading();
    return fetchMID({ canal: 'gpschile' }, 'marcaBlanca/getClient')
      .then((data: any) => {
        if (data.data.CODIGO_RESPUESTA == '1') {
          this.cliente = data.data.data || [];
          const filteredDatas = this.cliente
            .map((item: { nombre: any; rut: any; id: any }) => ({
              nombre: item.nombre,
              rut: item.rut,
              id: item.id,
            }))
            .sort((a: any, b: any) => {
              if (a.nombre > b.nombre) {
                return 1;
              } else if (a.nombre < b.nombre) {
                return -1;
              } else {
                return 0;
              }
            });

          if (filteredDatas.length > 0) {
            this.clientesall = filteredDatas;
            this.clientesAll = filteredDatas;
          }

          const clienteMid = sessionStorage.getItem('clienteMid');

          // Si hay un valor, busque el ID correspondiente en la lista de clientes
          if (clienteMid) {
            const clienteId = parseInt(clienteMid, 10);
            const clienteEncontrado = this.clientesAll.find(
              (cliente: { id: number }) => cliente.id === clienteId
            );

            if (clienteEncontrado) {
              // Seleccione el cliente encontrado
              this.formFields.clientes.value = clienteEncontrado.id;
            }
          }
          return data.data.data;
        } else {
          self.$snotify.error(data.data.MENSAJE_RESPUESTA, { timeout: 3000 });
        }
      })
      .catch((error: any) => {
        self.$snotify.error('Ocurrió un error', { timeout: 3000 });
      })
      .finally(() => {
        this.loadingService.hideLoading();
        return null;
      });
  }

  beforeDestroy() {}

  moduloModalCallback(val: boolean) {
    this.showModalNew = val;
    this.showModalEdit = val;
    this.showModalAsignar = val;
    //this.obtenerMayor()+1;
  }

  confirmCallbackConfirm(val: boolean) {
    this.dialogConfirmacionClose = false;
    this.showModalNew = false;
  }
}
